import { render, staticRenderFns } from "./IcSearch.vue?vue&type=template&id=b9fd8d68&scoped=true"
import script from "./IcSearch.vue?vue&type=script&lang=js"
export * from "./IcSearch.vue?vue&type=script&lang=js"
import style0 from "./IcSearch.vue?vue&type=style&index=0&id=b9fd8d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fd8d68",
  null
  
)

export default component.exports